/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Box, Typography } from "@mui/material";

const ImageDeleteDialogPanel = (props) => {
    const deleteType = props.deleteType;

    return (
        <Fragment>
            <Box
                elevation={3}
                style={{
                    padding: "24px",
                    margin: "0 12px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        // width: '100%',
                        margin: "auto",
                        // maxWidth: '760px',
                        // padding: '24px',
                        alignContent: "center",
                    }}
                >
                    {deleteType === "REMOVE" && (
                        <>
                            <Typography variant='h2'>Remove image.</Typography>
                            <Typography variant='subtitle1' mt={3}>
                                Please confirm you want to remove this image from where it was set.
                            </Typography>
                            <Typography variant='subtitle1' mt={3}>
                                The image will still be available in the SimpliCity Image Library.
                            </Typography>
                        </>
                    )}

                    {deleteType === "DELETE" && (
                        <>
                            <Typography variant='h2'>Delete image from Library.</Typography>
                            <Typography variant='subtitle1' mt={3}>
                                Please confirm you want to remove this image from where it was set.
                            </Typography>
                            <Typography variant='subtitle1' mt={3}>
                                The image will still be available in the Image Library.
                            </Typography>
                        </>
                    )}
                </div>
            </Box>
        </Fragment>
    );
};

export { ImageDeleteDialogPanel };
